module.exports = __webpack_public_path__ + "static/media/profilpic-1.c35fec03.png";